export const CANCELED_BY_USER = "Canceled by user"
